import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exploracion',
  templateUrl: './exploracion.component.html',
  styleUrls: ['./exploracion.component.css']
})
export class ExploracionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/exploracion/exploracion.component.ts